import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faHashtag, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        nit_comercializador: '',
        nombre: '',
        rep_legal: '',
        direccion_comer: '',
        correo_electronico_comer: '',
        resp_comer: '',
        cargo_resp_comer: '',
        telefono_resp_comer: '',
        correo_electronico_resp_comer: '',
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { nit_comercializador, nombre, rep_legal, direccion_comer, correo_electronico_comer, resp_comer, cargo_resp_comer, telefono_resp_comer, correo_electronico_resp_comer } = this.state;
        var errores = [];
        if (!nombre) { errores.push("error_nombre"); }
        if (!nit_comercializador) { errores.push("error_nit_comercializador"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        var datosEnviar = {
            nombre: nombre,
            nit_comercializador: nit_comercializador,
            rep_legal: rep_legal,
            direccion_comer: direccion_comer,
            correo_electronico_comer: correo_electronico_comer,
            resp_comer: resp_comer,
            cargo_resp_comer: cargo_resp_comer,
            telefono_resp_comer: telefono_resp_comer,
            correo_electronico_resp_comer: correo_electronico_resp_comer
        }
        Swal.showLoading();
        authAxios.post("comercializadores/registrar", datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Comercializadoras!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterComercializadores");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Comercializadoras!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    render() {
        const { nit_comercializador, nombre, rep_legal, direccion_comer, correo_electronico_comer, resp_comer, cargo_resp_comer, telefono_resp_comer, correo_electronico_resp_comer } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRO DE COMERCIALIZADORAS</b>
                            </div>
                            <div className="card-body">
                            <form onSubmit={this.enviarDatos}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="nit_comercializador">NIT Comercializadora</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_nit_comercializador")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="nit_comercializador" id="nit_comercializador" value={nit_comercializador} placeholder="NIT COMERCIALIZADORA" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el NIT Comercializadora</small>
                                                </div>
                                                <div className="col-md-10">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="nombre" id="nombre" value={nombre} placeholder="NOMBRE" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-4">
                                                    <label htmlFor="rep_legal">Repr. Legal</label>
                                                    <input style={{ textTransform: 'uppercase' }} className="form-control form-control-sm" type="text" name="rep_legal" id="rep_legal" value={rep_legal} placeholder="REPR. LEGAL" aria-describedby="helpId" onChange={this.cambioValor} />
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="direccion_comer">Dirección</label>
                                                    <input style={{ textTransform: 'uppercase' }} className="form-control form-control-sm" type="text" name="direccion_comer" id="direccion_comer" value={direccion_comer} placeholder="DIRECCIÓN" aria-describedby="helpId" onChange={this.cambioValor} />
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="correo_electronico_comer">Correo Electrónico</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className="form-control form-control-sm" type="text" name="correo_electronico_comer" id="correo_electronico_comer" value={correo_electronico_comer} placeholder="CORREO ELECTRÓNICO" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="resp_comer">Responsable</label>
                                                    <input style={{ textTransform: 'uppercase' }} className="form-control form-control-sm" type="text" name="resp_comer" id="resp_comer" value={resp_comer} placeholder="RESPONSABLE" aria-describedby="helpId" onChange={this.cambioValor} />
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="cargo_resp_comer">Cargo Responsable</label>
                                                    <input style={{ textTransform: 'uppercase' }} className="form-control form-control-sm" type="text" name="cargo_resp_comer" id="cargo_resp_comer" value={cargo_resp_comer} placeholder="CARGO RESPONSABLE" aria-describedby="helpId" onChange={this.cambioValor} />
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="telefono_resp_comer">Telefono Responsable</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className="form-control form-control-sm" type="text" name="telefono_resp_comer" id="telefono_resp_comer" value={telefono_resp_comer} placeholder="TELEFONO RESPONSABLE" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="correo_electronico_resp_comer">Correo Electrónico Responsable</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className="form-control form-control-sm" type="text" name="correo_electronico_resp_comer" id="correo_electronico_resp_comer" value={correo_electronico_resp_comer} placeholder="CORREO ELECTRÓNICO RESP." aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Comercializadora</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterComercializadores"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;